import { render, staticRenderFns } from "./createdThird.vue?vue&type=template&id=1be28224&scoped=true"
import script from "./createdThird.vue?vue&type=script&lang=js"
export * from "./createdThird.vue?vue&type=script&lang=js"
import style0 from "./createdThird.vue?vue&type=style&index=0&id=1be28224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be28224",
  null
  
)

export default component.exports